import Header from "../component/header";
import Footer from "../component/footer";
import Lenis from 'lenis'

function Policy() {
        const lenis = new Lenis({
        duration: 2.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        direction: 'vertical', // vertical, horizontal
        gestureDirection: 'vertical', // vertical, horizontal, both
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: true,
        touchMultiplier: 2,
        infinite: false,
      })

//get scroll value
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
console.log({ scroll, limit, velocity, direction, progress })
})

function raf(time) {
lenis.raf(time)
requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

    return (
    <main>
       <Header/>

          <div id="smooth-wrapper">
        <div id="smooth-content">
            {/* <!-- Add your site or application content here --> */}
            <main>

                {/* <!-- page title area start --> */}
                <section className="page-title-area section-spacing primary-bg p-relative adjust-header-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-9">
                                <div className="page-title-wrappper is-white">
                                    <div className="breadcrumb-menu mb-20">
                                        <nav aria-label="Breadcrumbs" className="breadcrumb-trail breadcrumbs">
                                            <ul className="trail-items">
                                                <li className="trail-item trail-begin"><span>Effective Date:</span></li>
                                                <li className="trail-item"><span>May 1, 2025</span></li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <h2 className="page-title mb-35 animation__word_come_long">Privacy Policy for Ally – AI Virtual Assistant</h2>
                                    {/* <!-- <p className="page-title-paragraph xlarge p-text">We showcased how our skilled hands and
                                        creative minds turn a concept into a fully-functional product. Here, you will
                                        discover satisfied clients with amazing stories!</p> --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- page title area end --> */}
                <section className="section-spacing">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12">

                                <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> Scope of the Policy</h4>
                            <p className="mb-55">
                                This Privacy Policy applies to all users of Ally, including employees, candidates, clients,
                                prospective customers, and other individuals who interact with the assistant for pre-sales
                                or HR-related purposes.</p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> Information We Collect</h4>
                            <p className="mb-55">
                                Ally may collect the following types of information:<br />
                                2.1 Personal Information<br />
                                - Full Name<br />
                                - Email Address<br />
                                - Phone Number<br />
                                - Job Title and Department<br />
                                - Employment-related information (for internal HR queries)<br />
                                - Organization name (for prospective customers)<br />
                                - Any other information voluntarily provided during chat interaction
                                2.2 Usage Data<br />
                                - Log and session information<br />
                                - Device and browser type<br />
                                - Date and time of interaction<br />
                                - Duration of sessions<br />
                                2.3 Communication Data<br />
                                - Chat transcripts and related queries</p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> How We Use Your Information</h4>
                            <p className="mb-55">
                                We use the information collected through Ally to:<br />
                                - Respond to your queries efficiently<br />
                                - Facilitate pre-sales interactions<br />
                                - Provide HR support within your organization<br />
                                - Improve our AI model’s accuracy and user experience<br />
                                - Maintain security and integrity of our services<br />
                                - Comply with legal and regulatory obligations</p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> Data Sharing and Disclosure</h4>
                            <p className="mb-55">
                                We do not sell your personal data.<br />
                                We may share information:<br />
                            
                                - With authorized personnel within your organization (for HR queries)<br />
                                - With our service providers (e.g., cloud hosting and NLP tools) under strict confidentiality
                                agreements<br />
                                - When required by law, legal proceedings, or governmental requests<br />
                                - In the event of a merger, acquisition, or sale of assets (with due notification)</p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> Data Security</h4>
                            <p className="mb-55">
                                We implement appropriate technical and organizational measures to protect your
                                information against unauthorized access, alteration, disclosure, or destruction. However, no
                                electronic transmission or storage method is 100% secure.</p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> Data Retention</h4>
                            <p className="mb-55">
                                We retain data only for as long as necessary to:<br />
                                - Fulfill the purposes described in this policy<br />
                                - Comply with legal obligations<br />
                                - Resolve disputes and enforce agreements<br />
                                Retention periods may vary depending on the nature of the interaction.<br />
                            </p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> User Rights</h4>
                            <p className="mb-55">
                                Depending on your jurisdiction, you may have the right to:<br />
                                - Access the personal data we hold about you<br />
                                - Request correction or deletion of your data<br />
                                - Withdraw consent to data processing (where applicable)<br />
                                - Lodge a complaint with a supervisory authority<br />
                                To exercise these rights, contact us at support@mystra.in.
                            </p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> Use by Minors</h4>
                            <p className="mb-55">
                                Ally is not intended for use by individuals under the age of 18. We do not knowingly collect
                                personal information from minors. If you believe a minor has submitted data, please contact
                                us so we can delete it.</p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> Third-Party Services</h4>
                            <p className="mb-55">
                                Ally may integrate with or redirect you to third-party platforms (e.g., CRMs, HRMS tools).
                                We are not responsible for the privacy practices of such platforms. We encourage you to
                                read their privacy policies.</p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> Changes to this Privacy Policy</h4>
                            <p className="mb-55">
                                We may update this Privacy Policy periodically. Changes will be posted with an updated
                                effective date. We encourage you to review this policy regularly.</p>
                            
                            <h4 className="case-subtitle mb-25"><span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M3.23197 8L0 9.90086L2.38215 14.0991L5.616 12.2016L5.61782 16H10.3822L10.384 12.2016L13.6178 14.0991L16 9.90086L12.768 8L16 6.09914L13.6178 1.90086L10.384 3.79843L10.3822 0H5.61782L5.616 3.79843L2.38215 1.90086L0 6.09914L3.23197 8Z"
                                            fill="#14CF93" />
                                    </svg>
                                </span> Contact Us </h4>
                            <p className="mb-55">
                                If you have questions, concerns, or complaints about this Privacy Policy or your data, please
                                contact us at:</p>

                                <h4 className="case-subtitle mb-25">
                                    Mystra Technologies LLP<br/>
                                    Email: support@mystra.in
                                </h4>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- faq area end --> */}
                {/* <!-- title intro area --> */}
                <section className="title-intro-area">
                    <div className="container">
                        <div className="title-intro-wrapper is-center section-spacing">
                            <div className="intro__title-wrapper">
                                <h2 className="intro__title-inner folks-text">Let’s talk.</h2>
                            </div>
                            <div className="intro-brn">
                                <a href="/mystra-contact" className="circle-btn is-green">
                                    <span className="icon-box"><i className="flaticon-next"></i></span>
                                    <img src="assets/img/icons/contact-btn-text.png" alt="mystra-policy"
                                        className="image-text"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <!-- title intro end --> */}

            </main>

            {/* <!-- footer-area-start --> */}
              <Footer/>
            {/* <!-- footer-area-end --> */}
        </div>
    </div>

    {/* <!-- back to top start --> */}
    <div className="progress-wrap">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
    {/* <!-- back to top end --> */}
    </main>
)}

export default Policy;
    